
import styled from 'styled-components';
 

const MapContainer = styled.div` 
  width: 100%;
  max-width: 600px;
  height: 450px;
  border: 0;
  margin-top: 20px;
  overflow: hidden;

  
`;


 
function SimpleMap() {
  return (
    <MapContainer>
      <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2614.9714356978207!2d-122.30083330000004!3d49.0491667!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548435f90caad88d%3A0x40f9edf4cadd0d22!2sTong%20Fei%20-%20Korean%20Chinese!5e0!3m2!1sen!2sca!4v1755993256732!5m2!1sen!2sca"y
         width="400"
        height="450"
        // width="350"
        // height="400
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Google Map"
      ></iframe>
  
    </MapContainer>
  );
}

export default SimpleMap;
